import React, { useEffect } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { TransformationSection } from './components/TransformationSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { AuthoritySection } from './components/AuthoritySection';
import { ReviewsSection } from './components/ReviewsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { LegacySection } from './components/LegacySection';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { loadMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    loadMetaPixel();
  }, []);
  return <div className="min-h-full w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3ik7jmqgv0tve">
      <AnnouncementBar data-id="element-1" data-mp="3ihuyy5jpw5en" />
      <main data-id="element-2" data-mp="3mlayb9n68jv1">
        <Hero data-id="element-3" data-mp="3mkrd9k285fcs" />
        <PainSection data-id="element-4" data-mp="3mkhnnxl3da7m" />
        <SolutionSection data-id="element-5" data-mp="3mjq1tehaqquj" />
        <TransformationSection data-id="element-6" data-mp="3mj6lu3b7icj5" />
        <WhatYouGetSection data-id="element-7" data-mp="3rbzlwdvqcwow" />
        <ReviewsSection data-id="element-8" data-mp="3rcsyvwla8ifh" />
        <OfferSection data-id="element-9" data-mp="3reltuemj9e7n" />
        <AuthoritySection data-id="element-10" data-mp="5orh0l86u6j" />
        <ForWhoSection data-id="element-11" data-mp="4wxfu7a14id" />
        <FaqSection data-id="element-12" data-mp="56nfhsbnbo2" />
        <LegacySection data-id="element-13" data-mp="7svdij4jt6t" />
      </main>
      <Footer data-id="element-14" data-mp="2zlv66six0xu0" />
      <PurchaseNotifications data-id="element-15" data-mp="2zm4v0cs84yy4" />
    </div>;
}